/**
 * Shared metrics for the pagination controls.
 *
 * Page buttons and the page-size trigger share `CONTROL_SIZE` so the strip
 * reads as one band. The prev/next chevron buttons are deliberately larger
 * per the design — they're the row's fixed, always-present controls, and the
 * bigger hit target sets them apart from the numbered pages. The numbers live
 * here rather than in each part's StyleSheet so they cannot drift apart.
 */
export const CONTROL_SIZE = 28;
export const NAV_CONTROL_SIZE = 36;
export const CHEVRON_SIZE = 16;
